export default "__VITE_ASSET__DgFiZ$57__"